import React from "react";
import "../../Assessts/Styles/Home.scss";
import { Row, Col } from "react-bootstrap";

import SlidingFrame from "./SlideingFrame";

import Assessments from "../../Assessts/Images/Home/Assessments.svg";
import Schools from "../../Assessts/Images/Home/Schools.svg";
import Students from "../../Assessts/Images/Home/Students.svg";
import SYstems from "../../Assessts/Images/Home/Systems.svg";

import AboutUs from "../../Assessts/Images/Home/AboutUs.png";
import Vision from "../../Assessts/Images/Home/Vision.png";
import Mission from "../../Assessts/Images/Home/Mission.png";
import Star from "../../Assessts/Images/Home/Star.svg";

import Ncpwork from "../../ReUableComponents/ncpwork.jsx";
import SlidingWithButtons from "./SlidingwithButtons.jsx";
import Patners from "./Patners.jsx";

import Vacancy from "../../Assessts/Images/Home/vacancy.svg";
import Volunteer from "../../Assessts/Images/Home/volunteer.svg";
import { useNavigate } from "react-router-dom";
const Home = () => {
    const navigate = useNavigate();
    const DetailsNCP = [
        { Name: "Assessments", value: "325+", icon: Assessments },
        { Name: "Schools Reached", value: "2,134+", icon: Schools },
        { Name: "Students Impacted", value: "3,42,000+", icon: Students },
        { Name: "School Systems", value: "15+", icon: SYstems },
    ]
    return (
        <>
            <SlidingFrame />
            <div className="dflex gap-5  JCCenter mt-5 mb-5 NCP-DetailsMainDiv">
                {DetailsNCP.map((item) => (
                    <div className="dflex flexd-column alignitems gap-2 NCPDetails">
                        <span>{item?.value}</span>
                        <span>{item?.Name}</span>
                        <span className="NCPDetails-icon"><img src={item?.icon} alt={item?.Name} /></span>
                    </div>
                ))}
            </div>

            <div className="dflex H-Aboutus">
                <div>
                <img src={AboutUs} alt="About Us" /></div>
                <div className="p-4">
                    <span className="Web-MainHeading" style={{ justifyContent: "flex-start" }}>About Us</span>
                    <p>NSF Competency Program (NCP) is an educational initiative by NorthSouth Foundation that supports competency-based learning and assessment for students. NCP provides curriculum-aligned, competency-focused assessments that help measure how well students understand and apply concepts, not just memorize them. The platform also offers analytical feedback and performance insights to support students, teachers, and schools in improving learning outcomes.</p>
                    <p className="mt-3">NCP focuses on competency-based learning to help students move beyond rote memorization. Its assessments are designed to measure real understanding and skill mastery, enabling better learning outcomes and meaningful academic growth</p>
                </div>
            </div>

            <div className="p-3" style={{ backgroundColor: "#F6F2ED" }}>
                <div className="dflex JCCenter flexd-column alignitems HCBL">
                    <span className="Web-MainHeading mb-3">What is Competency-Based Learning?</span>
                    <p >Competency-Based Learning focuses on measuring what students truly understand and are able to do, rather than how well they memorize information. It emphasizes mastery of concepts, practical application of knowledge, and skill development, allowing learners to progress by demonstrating understanding and competency aligned to the curriculum.</p>
                    <button className="Website-Buttons mt-3 mb-3" onClick={() => navigate("/Competency Base Learning")}>Learn More</button>
                </div>
                <div className="container-fluid mt-3">
                    <Row>
                        <Col><img src={Vision} alt="Our Vision" className="w-100 h-75  " />
                            <div className="OURVM"> <span className="Web-SubHeading">Our Vision</span>
                                <p> <img src={Star} alt="Star" />Excellence in education, empathy, and social entrepreneurship.</p></div>
                        </Col>
                        <Col>
                            <div className="OURVM">
                                <span className="Web-SubHeading">Our Mission</span>
                                <p><img src={Star} alt="Star" />Provide every child with opportunity and equity to educational
                                    access</p>
                                <p><img src={Star} alt="Star" />Empower every child to be an empathetic and holistic leader</p>
                                <p><img src={Star} alt="Star" />Provide a platform for volunteers to come together to support
                                    their Communities</p>
                            </div>
                            <img src={Mission} alt="Our Mission" className="w-100 " /></Col>
                    </Row></div>
            </div>
            <Ncpwork />
            <SlidingWithButtons />
            <Patners />
            <div className="pb-4" style={{backgroundColor:"#F9FBFF"}}>
            <div className="Web-MainHeading">Join us in making a difference</div>
            <div className="dflex JCCenter gap-3 mt-3 JMD">
                <button className="Website-Buttons "><img src={Vacancy} alt="Vacancy" />Vacancy</button>
                <button className="Website-Buttons " onClick={() => window.open("https://portal.northsouth.org/app6/VolunteerLogin.aspx", "_blank")}> <img src={Volunteer} alt="Volunteer" />Volunteer</button>
              </div>  
            </div>
        </>
    )
}
export default Home;